import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from "ng2-translate";
import { Router, ActivatedRoute } from "@angular/router";
import { animate, style, transition, trigger, state } from '@angular/animations';
import { Subscription } from 'rxjs';
import { MediaMatcher } from '@angular/cdk/layout';
import { UserService } from '../../_services/user.service';
import { Observable } from 'rxjs/Observable';
import { MatDialog } from '@angular/material';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { Http } from '@angular/http';
import { animation } from '@angular/core/src/animation/dsl';
import { AngularFirestore } from 'angularfire2/firestore';
@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css'],
  animations: [

    trigger(
      'myAnimation2',
      [
        transition(
          ':enter', [
            style({ transform: 'translateY(-100%)', opacity: 0 }),
            animate('500ms', style({ transform: 'translateY(0)', 'opacity': 1 }))
          ]
        ),
        transition(
          ':leave', [
            style({ transform: 'translateY(0)', 'opacity': 1 }),
            animate('500ms', style({ transform: 'translateY(-100%)', 'opacity': 0 }))
          ]
        )])

  ]
})
export class LandingPageComponent implements OnInit {
  private subscription: Subscription = new Subscription();
  brandName: string;
  brandRate: Observable<any[]>;
  brand: any;
  uniqueName: string;
  userId = this.userService.getUid();
  user: any;
  brandCategories: Observable<any[]>;
  model: any;
  mode: boolean;
  averageRate: any;
  categoryButtonText: any;
  mobileQuery: any;
  openMenu = false;
  oldvalues = {

  }
  private _mobileQueryListener: () => void;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    public translate: TranslateService,
    private media: MediaMatcher,
    private dialog: MatDialog,
    private http: Http,
    private cd: ChangeDetectorRef,
    private afs: AngularFirestore,
    private cdr: ChangeDetectorRef) {
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
    }));
    this.mobileQuery = this.media.matchMedia('(max-width: 1024px)');
    this._mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.subscription.unsubscribe();
  }

  ngOnInit() {

    this.mode = this.route.snapshot.queryParams['mode'] == 3;
    this.subscription.add(this.route.params.subscribe(params => {
      const url = decodeURIComponent(this.router.url);
      if (url.indexOf("#") != -1) {
        this.brandName = params["uniqueName"].split("#")[0];
        this.uniqueName = (url.split("#")[0] || url.split("#")[0].split("/")[2]) + "/hashtags/" + url.split("#")[1];
      } else {
        this.brandName = this.uniqueName = params["uniqueName"];
      }
      this.afs.collection('brands').ref.where('uniqueName', '==', this.brandName).get().then((data => {
        this.brand = data.docs[0].data();
      }));
      // let array: any[] = [];
      // this.afs.collection('brands').doc(data.docs[0].id).collection('categories').ref.get().then((category => {
      //   category.docChanges.map((el) => {
      //     if (el.doc.data().name === 'Genel') {
      //       this.averageRate = el.doc.data().total / el.doc.data().peopleCount;
      //       this.categoryButtonText = el.doc.data().name == 'Genel' ? 'Marka Puanı' : name;
      //     }

      //   })
      //   this.afs.collection('brands').doc(data.docs[0].id).collection('categories').ref.where('name', '==', 'Genel')
      //     .get().then((cri) => {
      //       this.brandRate = cri.docs[0].data().criterias;
      //     })
      // }))
      // this.brandCategories = this.afs.collection('brands').doc(data.docs[0].id).collection('categories').valueChanges();

    }));

    localStorage.clear();
  }
  getIpAdress(): Observable<any> {
    return this.http.get("https://api.bigadvice.com/helper/ip")
      .map(data => data.json());
  }

  joinUs(email) {
    if (email.replace(/\s/g, '') == '') {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "E-posta adresini yazmalısın!",
          type: "update"
        }
      });
      return;
    }
    this.getIpAdress().subscribe(data => {
      this.afs.collection('newsLetter').add({
        email: email,
        modifyDate: Date.now(),
        ipAdress: data
      }).then(() => {
        this.dialog.open(SaveMessageComponent, {
          width: '400px',
          data: {
            message: "Bilgilerin iletilmiştir, teşekkürler.",
            type: "update"
          }
        });
      });
    });

  }
  // openMenu($event){
  //   this.oldvalues=$event;
  //   console.log(this.oldvalues);
  //   this.menuOpen=true;
  // }
  menuOpen() {
    this.openMenu = true;
  }
  menuClose() {
    this.openMenu = false;
  }
  choseCategory(string) {
    this.categoryButtonText = string == 'Genel' ? 'Marka Puanı' : string;

  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/landing-page/landing-page.component.ts